(() => {
  'use strict';

  if (window.EnigmaSearchTypewriter) {
    window.EnigmaSearchTypewriter.refresh();
    return;
  }

  const selector = 'input[data-enigma-search-prompt]';
  const mounts = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const letterDelay = 80;
  const completedDelay = 5000;

  function mount(input) {
    if (mounts.has(input)) return;
    const phrase = input.dataset.enigmaSearchPrompt;
    if (!phrase) return;
    const letters = Array.from(phrase);
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const mobileDrawer = input.closest('.enigma-mobile-drawer-search') && input.closest('#mobile_menu');
    let timer = 0;
    let cursor = 0;

    function stop() {
      window.clearTimeout(timer);
      timer = 0;
      input.placeholder = phrase;
    }

    function canAnimate() {
      return input.isConnected && !document.hidden && !reducedMotion.matches &&
        (mobileDrawer || document.activeElement !== input) && !input.value &&
        input.getClientRects().length > 0 && !input.closest('[inert], [aria-hidden="true"]');
    }

    function tick() {
      timer = 0;
      // Read the current value each time, including changes made by other controllers.
      if (!canAnimate()) {
        stop();
        return;
      }
      if (cursor === letters.length) {
        start();
        return;
      }
      cursor += 1;
      input.placeholder = letters.slice(0, cursor).join('');
      timer = window.setTimeout(tick, cursor === letters.length ? completedDelay : letterDelay);
    }

    function start() {
      stop();
      if (!canAnimate()) return;
      cursor = 0;
      input.placeholder = '';
      timer = window.setTimeout(tick, letterDelay);
    }

    input.addEventListener('focus', mobileDrawer ? start : stop, options);
    input.addEventListener('blur', start, options);
    input.addEventListener('input', start, options);
    input.addEventListener('change', start, options);
    if (input.form) input.form.addEventListener('submit', stop, options);
    const drawerObserver = mobileDrawer ? new MutationObserver(start) : null;
    if (drawerObserver) drawerObserver.observe(mobileDrawer, { attributes: true, attributeFilter: ['aria-hidden', 'inert'] });

    mounts.set(input, {
      start,
      dispose() {
        stop();
        abort.abort();
        if (drawerObserver) drawerObserver.disconnect();
        mounts.delete(input);
      }
    });
    start();
  }

  function refresh() {
    mounts.forEach((controller, input) => {
      if (!input.isConnected) controller.dispose();
    });
    document.querySelectorAll(selector).forEach(mount);
  }

  function resumeAll() {
    refresh();
    mounts.forEach(controller => controller.start());
  }

  window.EnigmaSearchTypewriter = { refresh };
  document.addEventListener('visibilitychange', resumeAll);
  window.addEventListener('pageshow', resumeAll);
  window.addEventListener('resize', resumeAll, { passive: true });
  reducedMotion.addEventListener('change', resumeAll);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    mounts.forEach((controller, input) => {
      if (event.target.contains(input)) controller.dispose();
    });
  });
  refresh();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  }
})();
